import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { BreakPointToken } from '../../hooks/useMediaQuery';
import { NoGapSupport } from '../../lib/utils/mixins';
import {
	colours,
	desktopGridGaps,
	InputWidths,
	mobileGridGap,
	size_16,
	size_20,
	size_8,
	submitBtnWidthDesktop,
	tabletGridGaps
} from './forms.styles';

export const inputWidths: InputWidths = {
	tablet: `calc((100% / 3) - ${2 * (tabletGridGaps.horizontal / 3)}px)`,
	desktop: `calc(((100% - ${submitBtnWidthDesktop}px) / 4) - ${desktopGridGaps.horizontal}px)`
};

export const hotelInputWidths: InputWidths = {
	tablet: `calc((100% / 2) - ${tabletGridGaps.horizontal / 2}px)`,
	desktop: `calc(((100% - ${submitBtnWidthDesktop}px) / 3) - ${desktopGridGaps.horizontal}px)`
};

export const mainColumn = css`
	flex: 0 0 100%;

	@media (min-width: ${BreakPointToken.MdMin}px) {
		flex: 0 0 calc(50% - ${tabletGridGaps.horizontal / 2}px);
	}

	&:first-of-type {
		margin-top: ${size_20 - mobileGridGap}px;

		@media (min-width: ${BreakPointToken.MdMin}px) {
			margin: 0;
		}
	}

	${NoGapSupport(
		() => css`
			@media (min-width: ${BreakPointToken.MdMin}px) {
				margin-top: ${tabletGridGaps.vertical}px;
				margin-left: ${tabletGridGaps.horizontal}px;

				&:nth-of-type(3),
				&:first-of-type {
					margin-left: 0;
				}
			}

			@media (min-width: ${BreakPointToken.LgMin}px) {
				margin-top: ${desktopGridGaps.vertical}px;
				margin-left: ${desktopGridGaps.horizontal}px;

				&:nth-of-type(3) {
					margin-left: ${desktopGridGaps.horizontal}px;
				}

				&:first-of-type {
					margin-left: 0;
				}
			}
		`
	)}
`;
